import React from 'react';
import { Modal } from '../ui';
import { Department } from '../../lib/types';

interface Props {
  open: boolean;
  onClose: () => void;
  formName: string; setFormName: (s: string) => void;
  formSku: string; setFormSku: (s: string) => void;
  formSize: string; setFormSize: (s: string) => void;
  formQty: number; setFormQty: (n: number) => void;
  formDept: string; setFormDept: (s: string) => void;
  formThreshold: number; setFormThreshold: (n: number) => void;
  busy: boolean;
  departments: Department[];
  onSubmit: () => void;
}

export function InventoryAddModal(p: Props) {
  const inputStyle: React.CSSProperties = { width: '100%', padding: '8px 10px', fontSize: 13, borderRadius: 8, border: '1px solid var(--border)', background: 'var(--bg)', color: 'var(--text)', fontFamily: 'inherit', boxSizing: 'border-box' };
  const selectStyle: React.CSSProperties = { ...inputStyle, cursor: 'pointer' };
  const labelStyle: React.CSSProperties = { display: 'block', fontSize: 11, fontWeight: 600, color: 'var(--text2)', marginBottom: 4 };

  return (
    <Modal
      open={p.open}
      onClose={p.onClose}
      size="md"
      title="Add Inventory Item"
      subtitle="Add a new item to track in your inventory."
      footer={
        <>
          <button className="btn btn-ghost" onClick={p.onClose} disabled={p.busy}>Cancel</button>
          <button className="btn btn-primary" onClick={p.onSubmit} disabled={p.busy}>{p.busy ? 'Saving…' : 'Add to Inventory'}</button>
        </>
      }
    >
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px 16px' }}>
        <div style={{ gridColumn: '1 / -1' }}>
          <label style={labelStyle}>Item Name *</label>
          <input value={p.formName} onChange={e => p.setFormName(e.target.value)} placeholder="e.g. Safety Boots" style={inputStyle} />
        </div>
        <div><label style={labelStyle}>SKU / Code</label><input value={p.formSku} onChange={e => p.setFormSku(e.target.value)} placeholder="Optional" style={inputStyle} /></div>
        <div><label style={labelStyle}>Size</label><input value={p.formSize} onChange={e => p.setFormSize(e.target.value)} placeholder="Optional" style={inputStyle} /></div>
        <div><label style={labelStyle}>Quantity *</label><input type="number" value={p.formQty} min={1} onChange={e => p.setFormQty(parseInt(e.target.value) || 1)} style={inputStyle} /></div>
        <div>
          <label style={labelStyle}>Department *</label>
          <select value={p.formDept} onChange={e => p.setFormDept(e.target.value)} style={selectStyle}>
            <option value="">— Select —</option>
            {p.departments.map(d => <option key={d.id} value={d.id}>{d.name}</option>)}
          </select>
        </div>
        <div><label style={labelStyle}>Low Stock Threshold</label><input type="number" value={p.formThreshold} min={0} onChange={e => p.setFormThreshold(parseInt(e.target.value) || 0)} style={inputStyle} /></div>
      </div>
    </Modal>
  );
}
